<template>
  <div>
    <nodata-for-detail title="暂未填写入院交接单" v-if="noData">
      <p class="mt5 flex aic jcc" v-if="query.aspectUser==='accept'&&isAID_ADM">
        <el-button size="mini" type="primary" @click="$emit('add')">立即填写</el-button>
      </p>
    </nodata-for-detail>
    <template v-else>
      <print class="print" :print-css="env.printCss" ref="print">
        <p align=center><b><span><font
            face="宋体">危重患者院际转运病情交接单（转入）</font></span></b><b><span></span></b>
        </p>
        <table class="mt10" border=1 cellspacing=0 style="width: 100%;border-collapse: collapse;">
          <tr>
            <td width=103 valign=center rowspan=2>
              <p align=center><b><span>基本信息</span></b><b><span></span></b></p>
            </td>
            <td width=112 valign=center>
              <p align=center><span>姓名</span><span></span>
              </p>
            </td>
            <td valign=center>
              {{ info.patName }}
            </td>
            <td width=65 valign=center colspan=2>
              <p><span>性别</span><span></span>
              </p>
            </td>
            <td valign=center>
              {{ info.patGender|sexFilter }}
            </td>
            <td width=62 valign=center colspan=2>
              <p><span>年龄</span><span></span>
              </p>
            </td>
            <td valign=center>
              {{ info.patAge }}
            </td>
          </tr>
          <tr>
            <td valign=center>
              <p align=center><span>患方联系人</span><span
              ></span>
              </p>
            </td>
            <td valign=center>
              {{ info.familyContactsName }}
            </td>
            <td valign=center colspan=3>
              <p align=center><span>手机</span><span></span>
              </p>
            </td>
            <td valign=center colspan=3>
              {{ info.familyContactsMobile }}
            </td>
          </tr>
          <tr>
            <td valign=center rowspan=3>
              <p align=center><b><span>转运信息</span></b><b><span></span></b></p>
            </td>
            <td valign=center>
              <p align=center><span>出发医院</span><span
              ></span>
              </p>
              <p align=center><span>/<font face="宋体">科室</font></span><span
              ></span></p>
            </td>
            <td valign=center>
              {{ info.initHosName }}/{{ info.initDeptName }}
            </td>
            <td valign=center colspan=2>
              <p align=center><span>联系人</span><span
              ></span>
              </p>
            </td>
            <td valign=center>
              {{ info.initContactPerson }}
            </td>
            <td valign=center colspan=2>
              <p align=center><span>电话</span><span></span>
              </p>
            </td>
            <td valign=center>
              {{ info.initTelephone }}
            </td>
          </tr>
          <tr>
            <td valign=center>
              <p align=center><span>目的医院</span><span
              ></span>
              </p>
              <p align=center><span>/<font face="宋体">科室</font></span><span
              ></span></p>
            </td>
            <td valign=center>
              {{ info.acceptHosName }}/{{ info.acceptDeptName }}
            </td>
            <td valign=center colspan=2>
              <p align=center><span>联系人</span><span
              ></span>
              </p>
            </td>
            <td valign=center>
              {{ info.acceptContatPerson }}
            </td>
            <td valign=center colspan=2>
              <p align=center><span>电话</span><span></span>
              </p>
            </td>
            <td valign=center>
              {{ info.acceptTelephone }}
            </td>
          </tr>
          <tr>
            <td valign=center>
              <p align=center><span>转运车辆单位</span><span
              ></span>
              </p>
            </td>
            <td valign=center>
              {{ info.transportHosName }}
            </td>
            <td valign=center colspan=2>
              <p align=center><span>医师</span><b><span></span></b></p>
            </td>
            <td valign=center>
              {{ doc.emergencyPersonnelName }}
            </td>
            <td valign=center colspan=2>
              <p align=center><span>电话</span><b><span></span></b></p>
            </td>
            <td valign=center>
              {{ doc.emergencyPersonnelMobile }}
            </td>
          </tr>
          <tr>
            <td valign=center rowspan=2>
              <p align=center><b><span>主要病情</span></b><b><span></span></b></p>
            </td>
            <td valign=center>
              <p align=center><span>诊断</span><b><span></span></b></p>
            </td>
            <td valign=center colspan=7>
              {{ info.tentativeDiagnosis }}
            </td>
          </tr>
          <tr>
            <td valign=center>
              <p align=center><span>转运过程</span><span
              ></span>
              </p>
              <p align=center><span>病情变化</span><span
              ></span>
              </p>
            </td>
            <td valign=center colspan=7>
              {{ info.transhipmentProcessIllnessDesc }}
            </td>
          </tr>
          <tr>
            <td valign=center rowspan=7>
              <p align=center><b><span>目前状况</span></b><b><span></span></b></p>
            </td>
            <td valign=center>
              <p align=center><span>生命体征</span><span
              ></span>
              </p>
            </td>
            <td valign=center colspan=7>
              <p>
                <span>T {{ info.vitalSignsTemperature }}</span><span>&#8451;； </span><span>P {{
                  info.vitalSignsPulse
                }}<font
                    face="宋体">次</font><font
                    face="Times New Roman">/min</font><font
                    face="宋体">； </font><font
                    face="Times New Roman">R {{ info.vitalSignsRespire }}</font><font
                    face="宋体">次</font><font
                    face="Times New Roman">/min</font><font face="宋体">；</font></span><span
              ></span></p>
              <p><span>BP {{ info.vitalSignsBloodPressureUpper }}/{{ info.vitalSignsBloodPressureLower }}mmHg<font
                  face="宋体">；</font><font
                  face="Times New Roman">SpO</font></span><sub><span>2</span></sub><span>{{ info.vitalSignsSpo2 }}%<font
                  face="宋体">；疼痛评分 {{ info.painScore }}分</font></span><span
              ></span>
              </p>
            </td>
          </tr>
          <tr>
            <td valign=center>
              <p align=center><span>意识</span><span
              ></span>
              </p>
            </td>
            <td valign=center colspan=7>
              <p><span>GCS {{ info.gcsOpenEyesScore }}+ {{ info.ggcsLanguageScore }}+ {{ info.ggcsLimbsScore }}<font
                  face="宋体">分 </font></span><span
              ></span></p>
              <p><span>镇静<font face="Times New Roman">/</font><font
                  face="宋体">镇痛：</font></span><span><input type="radio" readonly disabled
                                                          :checked="info.easePainStatus===false">否     <input
                  type="radio" readonly disabled
                  :checked="info.easePainStatus">是   药物： {{ info.easePainMedicine }}</span><span
              ></span></p>
              <p>
                <span>瞳孔：左 </span><span>大小 {{ info.pupillaLeftSize }}<font
                  face="Times New Roman">mm</font><font
                  face="宋体">，</font></span><span>对光反射：{{ info.pupillaLeftLightReflex }}</span></p>
              <p><span>右 </span><span
              >大小 {{ info.pupillaRightSize }}<font face="Times New Roman">mm</font><font
                  face="宋体">，</font></span><span></span><span>对光反射：{{ info.pupillaRightLightReflex }}</span><span
              ></span></p>
            </td>
          </tr>
          <tr>
            <td valign=center>
              <p align=center><span>气道</span><span></span>
              </p>
            </td>
            <td valign=center colspan=7>
              <p><span><input type="checkbox"
                              :checked="info.noArtificialAirwaySelectStatus"
                              readonly disabled>无人工气道（<input type="checkbox"
                                                             :checked="info.noArtificialAirwaySafeSelectStatus"
                                                             readonly disabled>安全；<input
                  type="checkbox"
                  :checked="info.noArtificialAirwayNeedAttentionSelectStatus"
                  readonly disabled>需要注意）；</span><span
              ></span></p>
              <p><span><input type="checkbox"
                              :checked="info.trachealIntubationSelectStatus"
                              readonly
                              disabled>气管插管（深度 {{ info.trachealIntubationDepth }}<font
                  face="Times New Roman">cm</font><font face="宋体">）；<input type="checkbox"
                                                                           :checked="info.tracheostomySelectStatus"
                                                                           readonly
                                                                           disabled>气管切开</font></span><span
              ></span></p>
            </td>
          </tr>
          <!--<tr>
              <td  valign=center>
                  <p align=center><span>呼吸支持</span><span
                  ></span>
                  </p>
              </td>
              <td  valign=center colspan=7>
                  <p><span>&#9633; 自主呼吸：吸氧方式：&#9633; 鼻塞 &#9633; 面罩 </span><span
                  ></span></p>
                  <p><span
                  >&#163;</span><span
                  >储氧袋面罩，流量 升<font face="Times New Roman">/</font><font
                      face="宋体">分</font></span><span
                  ></span></p>
                  <p
                  ><span>&#9633; 辅助通气：模式 ，<font face="Times New Roman">Vt(P) </font><font
                      face="宋体">，</font><font
                      face="Times New Roman">F </font><font
                      face="宋体">，</font><font face="Times New Roman">FiO2 %</font><font
                      face="宋体">，</font><font
                      face="Times New Roman">PEEP </font><font
                      face="宋体">，</font><font face="Times New Roman">PSV </font></span><span>。</span><span
                  ></span></p>
              </td>
          </tr>-->
          <tr>
            <td valign=center>
              <p align=center><span>循环功能</span><span
              ></span>
              </p>
            </td>
            <td valign=center colspan=7>
              <p><span><input type="checkbox" readonly disabled
                              :checked="info.ductusArteriosusSelectStatus">动脉导管 {{
                  info.ductusArteriosusSelectDesc
                }}</span>
              </p>
              <p><span><input type="checkbox" readonly disabled
                              :checked="info.venousCatheterSelectStatus">静脉导管 {{ info.venousCatheterSelectDesc }}</span>
              </p>
              <p><span><input type="checkbox" readonly disabled
                              :checked="info.vasoactiveDrugsSelectStatus">血管活性药物</span><span> {{
                  info.vasoactiveDrugsSelectDesc
                }}</span><span
              ></span></p>
              <p><span><input type="checkbox" readonly disabled
                              :checked="info.cyclicFunctionOthersSelectStatus"></span><span>其他支持 {{
                  info.cyclicFunctionOthersSelectDesc
                }}</span><span
              ></span>
              </p>
            </td>
          </tr>
          <tr>
            <td valign=center>
              <p align=center><span>其他系统</span><span
              ></span>
              </p>
            </td>
            <td valign=center colspan=7>
              <p><span>腹部：外形<font
                  face="Times New Roman">-</font>{{ info.abdominalContour }}；肠鸣音 {{ info.intestinalSounds }}次</font>
                <font
                    face="Times New Roman">/min</font><font face="宋体">；<input type="checkbox"
                                                                              readonly
                                                                              disabled
                                                                              :checked="info.tendernessPainSelectStatus"> 压痛（部位： {{
                    info.tendernessPainSelectDesc
                  }}）</font></span><span
              ></span></p>
              <p><span>脊柱和骨盆： <input type="checkbox" readonly disabled
                                     :checked="info.spinalInjuriesSelectStatus">损伤 {{
                  info.spinalInjuriesSelectDesc
                }}；<input
                    type="checkbox" readonly disabled
                    :checked="info.spinalFixationSelectStatus"> 固定 {{ info.spinalFixationSelectDesc }}；</span><span
              ></span></p>
              <p><span>四肢：<input type="checkbox" readonly disabled
                                 :checked="info.limbFracturesSelectStatus"> 骨折 {{ info.limbFracturesSelectDesc }}；<input
                  type="checkbox" readonly disabled
                  :checked="info.limbInjuriesSelectStatus"> 伤口 {{ info.limbInjuriesSelectDesc }}；</span><span
              ></span></p>
              <p><span><input type="checkbox" readonly disabled
                              :checked="info.bloodVesselSelectStatus"> 血管问题 {{ info.bloodVesselSelectDesc }}；<input
                  type="checkbox" readonly disabled
                  :checked="info.nerveSelectStatus"> 神经问题 {{ info.nerveSelectDesc }}；</span><span
              ></span></p>
            </td>
          </tr>
          <tr>
            <td valign=center>
              <p align=center><span>管道情况</span><span
              ></span>
              </p>
            </td>
            <td valign=center colspan=7>
              <p><span><input type="checkbox" readonly disabled
                              :checked="info.catheterSelectStatus">导尿管 {{ info.catheterSelectDesc }}；</span><span
              ></span></p>
              <p><span><input type="checkbox" readonly disabled
                              :checked="info.drainageTubeSelectStatus">引流管 {{
                  info.drainageTubeSelectDesc
                }}；</span><span
              ></span></p>
              <p><span><input type="checkbox" readonly disabled
                              :checked="info.conduitSelectStatus"> 其它 {{ info.conduitSelectDesc }}；</span><span
              ></span></p>
            </td>
          </tr>
          <tr>
            <td valign=center>
              <p align=center><b><span>注意事项</span></b><b><span></span></b></p>
            </td>
            <td valign=top colspan=8>
              {{ info.mattersNeedingAttention }}
            </td>
          </tr>
          <tr>
            <td valign=center>
              <p align=center><b><span>交班人员</span></b><b><span></span></b></p>
            </td>
            <td valign=center>
              {{ info.handDutyName }}
            </td>
            <td valign=center colspan=2>
              <p align=center><span>时间</span><span></span>
              </p>
            </td>
            <td valign=center colspan=5>
              {{ info.handDutyTime|timeFilter('YYYY年MM月DD日HH时mm分ss秒') }}
            </td>
          </tr>
          <tr>
            <td valign=center>
              <p align=center><b><span>接班人员</span></b><b><span></span></b></p>
            </td>
            <td valign=center>
              {{ info.takeDutyName }}
            </td>
            <td valign=center colspan=2>
              <p align=center><span>时间</span><span></span>
              </p>
            </td>
            <td valign=center colspan=5>
              {{ info.takeDutyTime|timeFilter('YYYY年MM月DD日HH时mm分ss秒') }}
            </td>
          </tr>
          <tr>
            <td valign=center>
              <p align=center><b><span>备注</span></b><b><span></span></b></p>
            </td>
            <td valign=top colspan=8>
              {{ info.remark || '暂无' }}
            </td>
          </tr>
        </table>
      </print>
      <p class="print-hidden mt15 flex aic jcc" v-if="isAID_ADM">
        <el-button size="mini" type="primary" @click="$refs.print.print()">打印</el-button>
        <el-button v-if="query.aspectUser==='accept'" size="mini" type="primary" plain
                   @click="$emit('edit',info.id)">修改
        </el-button>
      </p>
    </template>
  </div>
</template>

<script>
import {staffService} from "../../staff/service/staff";
import NodataForDetail from "../../staff/components/nodata-for-detail";
import {isEmpty, pickByArray} from "../../../common/lib/utils";
import {STAFF_ADD_IN_OUT_FORM_SUCCESS} from "../../staff/events";
import {sexFilter, timeFilter} from "../../../common/lib/filters";
import Print from '@mathewparet/vue-print'
import {sync_in_out_form_field} from "../../staff/config";

export default {
  name: "zr-table",
  filters: {sexFilter, timeFilter},
  components: {NodataForDetail, Print},
  props: {
    id: {
      type: String,
      default: ''
    },
    data: Object,
    query: Object
  },
  data() {
    return {
      info: null
    }
  },
  computed: {
    doc() {
      const list = this.data.emergencyStaffingList && this.data.emergencyStaffingList.filter(r => r.emergencyPersonnelType === "DOC") || [];
      return list[0] || {};
    },
    noData() {
      return isEmpty(this.info);
    }
  },
  created() {
    bus.$on(STAFF_ADD_IN_OUT_FORM_SUCCESS.id, this.getInfo);
    this.getInfo();
  },
  beforeDestroy() {
    bus.$off(STAFF_ADD_IN_OUT_FORM_SUCCESS.id, this.getInfo);
  },
  methods: {
    async getInfo() {
      this.info = await staffService.detailApply(this.id, "IN");
      const outInfo = await staffService.detailApply(this.id, 'OUT');
      if (!isEmpty(outInfo)) {
        this.info = Object.assign({}, pickByArray(outInfo, sync_in_out_form_field), this.info);
      }
    }
  },
}
</script>

<style scoped>

</style>
